import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { toast } from "react-toastify";

const EmployeeKpiModal = ({ show, onHide, employee, filters }) => {

    const [dailyData, setDailyData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [supName, setSupName] = useState('');

    // 🔹 Get Month Name
    const getMonthName = (m) => {
        if (!m) return "";
        return [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ][m - 1];
    };

    // 🔹 Load Data when modal opens
    useEffect(() => {

        if (!show || !employee) return;

        const loadData = async () => {

            if (!filters?.month || !filters?.year) {
                toast.error("Month/Year missing");
                return;
            }

            setLoading(true);

            try {

                const res = await axios.get(`${BASE_URL}/api/get_Emp_Mthly_KPI_Modal`, {
                    params: {
                        emp_id: employee.emp_id,
                        month: filters.month,
                        year: filters.year
                    }
                });

                setDailyData(res.data || []);
                setSupName(res.data[0].supervisor_name);

            } catch (err) {
                console.error(err);
                toast.error("Error loading KPI details");
            } finally {
                setLoading(false);
            }
        };

        loadData();

    }, [show, employee, filters]);

    // 🔹 Calculations
    // const avgRating = dailyData.length
    //     ? (dailyData.reduce((a, b) => a + Number(b.sup_rating || 0), 0) / dailyData.length).toFixed(2)
    //     : 0;

    // const bestRating = dailyData.length
    //     ? Math.max(...dailyData.map(d => Number(d.sup_rating || 0)))
    //     : 0;

    return (

        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div>
                        <div style={{ fontSize: "18px", fontWeight: "600", marginBottom: '5px' }}> Employee Name :
                            {employee?.emp_name} - {getMonthName(filters?.month)} {filters?.year} 
                        </div>
                        <div style={{ fontSize: "18px", fontWeight: "600" }}> Supervisor Name :
                            {supName}
                        </div>
                    </div>
                    {/* {employee?.emp_name} - {getMonthName(filters?.month)} {filters?.year} */}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {/* 🔹 Loader */}
                {loading ? (
                    <div className="text-center p-4">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <>

                        {/* 🔹 Table */}
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {/* <div style={{ minHeight: '350px', overflowY: "auto" }} className="table-wrapper"> */}
                            <table className="table table-bordered table-hover responsive-table-modal scty-custom-table">
                            {/* <table style={{ maxHeight: '38px' }} className="responsive-table-modal scty-custom-table"> */}

                                <thead style={{ position: "sticky", top: 0, background: "#fff" }}>
                                    <tr>
                                        <th style={{ width: "10%" }}>Date</th>
                                        <th style={{ width: "35%" }}>KPI Name</th>
                                        <th style={{ width: "25%" }}>Employee Remark</th>
                                        <th style={{ width: "10%", textAlign: "right" }}>Supervisor <br/> Rating</th>
                                        <th style={{ width: "25%" }}>Supervisor Remark</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {dailyData.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}

                                    {dailyData.map((d, i) => (
                                        <tr
                                            key={i}
                                            style={{
                                                backgroundColor:
                                                    Number(d.sup_rating) < 60 ? "#ffe6e6" : ""
                                            }}
                                        >
                                            <td>{d.entry_date}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.kpi_name}</td>
                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.emp_rem}</td>

                                            <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                {d.sup_rating}
                                            </td>

                                            <td style={{ whiteSpace: "normal",wordBreak: "break-word"}}>{d.sup_rem}</td>
                                        </tr>
                                    ))}

                                </tbody>

                            </table>
                        </div>

                    </>
                )}

            </Modal.Body>

        </Modal>
    );
};

export default EmployeeKpiModal;
